import { Route, Routes } from "react-router-dom";
import Layout from "../Layout/Layout";
import AboutUs from "../screens/AboutUs/AboutUs";
import Team from "../screens/AboutUs/Team";
import Agenda from "../screens/Agenda/Agenda";
import Careers from "../screens/Careers/Careers";
import Contact from "../screens/Contact/Contact";
import EventandRegistration from "../screens/EventandRegistration/EventandRegistration";
import EventDetails from "../screens/EventandRegistration/EventDetails";
import PastEvents from "../screens/EventandRegistration/PastEvents";
import FAQ from "../screens/FAQ/FAQ";
import Gallery from "../screens/Gallery/Gallery";
import GalleryDetail from "../screens/Gallery/GalleryDetail";
import InnovatePhramaGallery from "../screens/Gallery/InnovatePhramaGallery";
import Home from "../screens/LandingPage/Home";
import Login from "../screens/Login/Login";
import PageNotFound from "../screens/PageNotFound/PageNotFound";
import AnnualConference2025 from "../screens/PastEvents/AnnualConference2025";
import InnovatePharma2024 from "../screens/PastEvents/InnovatePharma2024";
import Privacy from "../screens/Privacy/Privacy";
import Sponsors from "../screens/Sponsors/Sponsors";
import SubmitAbstract from "../screens/SubmitAbstract/SubmitAbstract";
import TermsandConditions from "../screens/TermsandConditions/TermsandConditions";
import Volunteer from "../screens/Volunteer/Volunteer";
import PharmasosConferenceHyderabad from "../screens/PastEvents/PharmasosConferenceHyderabad/PharmasosConferenceHyderabad";

const InnerRoutes = (props) => {
  return (
    <Layout {...props}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/teams" element={<Team />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route
          path="/events-and-registration"
          element={<EventandRegistration />}
        />
        <Route path="/event-details/:eventId" element={<EventDetails />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/become-a-volunteer" element={<Volunteer />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-and-conditions" element={<TermsandConditions />} />
        <Route path="/career" element={<Careers />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:slug" element={<GalleryDetail />} />
        <Route path="/abstract-submission" element={<SubmitAbstract />} />
        <Route path="/past-events" element={<PastEvents />} />

        {/* events pages */}
         <Route
          path="/pharmasos-conference-hyderabad"
          element={<PharmasosConferenceHyderabad />}
        />
        <Route
          path="/innovate-pharma-2024-bridging-continents-for-a-healthier-tomorrow"
          element={<InnovatePharma2024 />}
        />
        <Route
          path="/innovate-pharma-2024-bridging-continents-for-a-healthier-tomorrow-gallery"
          element={<InnovatePhramaGallery />}
        />
        <Route
          path="/pharma-sos-annual-conference-2025"
          element={<AnnualConference2025 />}
        />
        <Route path="/login" element={<Login />} />
        {/* page not found - catch all routes */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Layout>
  );
};

export default InnerRoutes;
